(function () {
  if (typeof window === 'undefined') return;

  var scrollLockY = 0;

  function lockPageScroll() {
    scrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('la-sizes-open');
    document.body.classList.add('la-sizes-open');
    document.body.style.top = '-' + scrollLockY + 'px';
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('la-sizes-open');
    document.body.classList.remove('la-sizes-open', 'overflow-hidden');
    document.body.style.top = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, scrollLockY);
  }

  function attachScrollUnlock(modal) {
    if (modal.dataset.sizesUnlockAttached) return;
    modal.dataset.sizesUnlockAttached = '1';

    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) {
        unlockPageScroll();
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function resetModalScroll(modal) {
    var dialog = modal.querySelector('.livia-sizes-modal__dialog');
    if (!dialog) return;
    dialog.scrollTop = 0;
    if (typeof dialog.scrollTo === 'function') {
      dialog.scrollTo(0, 0);
    }
  }

  function openSizesModal(modal, trigger) {
    lockPageScroll();
    modal.show(trigger);
    resetModalScroll(modal);
    requestAnimationFrame(function () {
      resetModalScroll(modal);
    });
  }

  document.body.addEventListener('modalClosed', function () {
    if (document.body.classList.contains('la-sizes-open')) {
      unlockPageScroll();
    }
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-sizes-trigger]');
    if (!trigger) return;

    var controls = trigger.getAttribute('aria-controls');
    var modal = controls
      ? document.getElementById(controls)
      : document.querySelector('modal-dialog.livia-sizes-modal');

    if (!modal || typeof modal.show !== 'function') return;

    event.preventDefault();
    openSizesModal(modal, trigger);
  });

  function initModals() {
    document.querySelectorAll('modal-dialog.livia-sizes-modal').forEach(function (modal) {
      attachScrollUnlock(modal);
    });
  }

  document.addEventListener('DOMContentLoaded', initModals);
  document.addEventListener('shopify:section:load', initModals);
})();
